import IosBridge from "utils/IosBridge";

export default class AppBridgeHelper {
  static cachedBridge = undefined;

  static getBridge() {
    if (this.cachedBridge) {
      return this.cachedBridge;
    }
    this.cachedBridge = this.#detectBridge();
    return this.cachedBridge;
  }

  static #detectBridge() {
    try {
      if (window.chrome?.webview?.hostObjects?.bridge) {
        return window.chrome.webview.hostObjects.bridge;
      }

      // ✅ Android (JavascriptInterface injected)
      if (window.AndroidBridge) {
        return window.AndroidBridge;
      }

      // ✅ iOS (WKWebView message handler injected)
      if (window.webkit?.messageHandlers?.iosBridge) {
        return new IosBridge(window.webkit.messageHandlers.iosBridge);
      }

      return null;
    } catch (error) {
      console.error("Bridge detection failed:", error);
      return null;
    }
  }

  static getPlatform() {
    const bridge = this.getBridge();
    if (!bridge) return "web";
    if (bridge instanceof IosBridge) return "ios";
    if (window.AndroidBridge && bridge === window.AndroidBridge) return "android";
    if (window.chrome?.webview?.hostObjects?.bridge) return "windows";
    return "unknown";
  }
}
